import { useIntl } from 'react-intl';
import { displayDateFormatOptions } from 'utils/date';

export interface RangeTriggerDisplayProps {
  startDate: string;
  endDate: string;
  className?: string;
}
export function RangeTriggerDisplay({ startDate, endDate, className }: RangeTriggerDisplayProps) {
  const { formatDate } = useIntl();
  return (
    <div className={className}>
      {formatDate(startDate, displayDateFormatOptions)} - {formatDate(endDate, displayDateFormatOptions)}
    </div>
  );
}
